import React from 'react';
import { cn } from '@/lib/utils';
import { TrendingUp } from 'lucide-react';

const colorMap = {
  emerald: { bg: 'bg-emerald-50', icon: 'bg-emerald-100 text-emerald-600', accent: 'text-emerald-600' },
  indigo:  { bg: 'bg-indigo-50',  icon: 'bg-indigo-100 text-indigo-600',   accent: 'text-indigo-600' },
  blue:    { bg: 'bg-blue-50',    icon: 'bg-blue-100 text-blue-600',       accent: 'text-blue-600' },
  amber:   { bg: 'bg-amber-50',   icon: 'bg-amber-100 text-amber-600',     accent: 'text-amber-600' },
  purple:  { bg: 'bg-purple-50',  icon: 'bg-purple-100 text-purple-600',   accent: 'text-purple-600' },
  rose:    { bg: 'bg-rose-50',    icon: 'bg-rose-100 text-rose-600',       accent: 'text-rose-600' },
};

export default function StatCard({ icon: Icon, title, value, subtitle, color = 'indigo' }) {
  const c = colorMap[color] || colorMap.indigo;
  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5 relative overflow-hidden">
      <div className={cn('absolute top-0 right-0 w-28 h-28 rounded-bl-full -z-0 opacity-60', c.bg)} />
      <div className="relative z-10">
        <div className="flex items-center justify-between">
          <h3 className="text-slate-500 text-xs font-medium uppercase tracking-wide">{title}</h3>
          <div className={cn('h-9 w-9 rounded-full flex items-center justify-center', c.icon)}>
            <Icon className="h-4 w-4" />
          </div>
        </div>
        <p className="text-2xl font-bold text-slate-900 mt-3">{value}</p>
        {subtitle && (
          <span className={cn('text-xs font-medium flex items-center gap-1 mt-1', c.accent)}>
            <TrendingUp className="h-3 w-3" /> {subtitle}
          </span>
        )}
      </div>
    </div>
  );
}
